/* ETIHAD55 campaign helpers for the CODE theme. Runs after code.js and does not change it:
   - countdown: ticks every second; at zero it removes every campaign element (offer has ended)
   - homepage hero: rotates the watches (pauses off-screen / in background tabs, static with reduced motion)
   - product page: keeps "your price with code" in step with the selected size
   - quick-add sheet: adds the "with code" line for eligible products
   - copy buttons for the banner and offer row
   - cart: "Apply" asks Shopify to add the code; the cart only changes after Shopify confirms it is applicable */
(() => {
  'use strict';
  const C = window.CODE || { routes: {} };
  const AR = document.documentElement.dir === 'rtl';
  const root = (C.routes.root || '/').replace(/\/?$/, '/');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('no-motion');
  const T = AR
    ? { withCode: 'مع الكود', err: 'تعذّر تطبيق الكود هنا. أدخله عند الدفع.' }
    : { withCode: 'With code', err: 'The code could not be applied here. Enter it at checkout.' };
  const fmt = (c) => { const n = (c / 100).toFixed(2).replace(/\.00$/, ''); const [i, d] = n.split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (d ? '.' + d : ''); };
  const money = (c) => { const tpl = document.getElementById('c-money-tpl'); if (!tpl) return fmt(c); const el = tpl.content.firstElementChild.cloneNode(true); const n = el.querySelector('.c-money__n'); if (n) n.textContent = fmt(c); return el.outerHTML; };
  const esc = (s) => String(s).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
  const line = (price, code, amt, size) => `<span class="c-eh55${size ? ' c-eh55--' + size : ''}" data-eh55 data-eh55-code="${esc(code)}" data-eh55-amount="${amt}"><span class="c-eh55__now">${money(Math.max(0, price - amt))}</span><span class="c-eh55__label">${T.withCode} <b dir="ltr">${esc(code)}</b></span></span>`;
  const shown = (box) => { const n = box && box.querySelector('.c-price__now .c-money__n'); if (!n) return null; const v = parseFloat(n.textContent.replace(/,/g, '')); return isNaN(v) ? null : Math.round(v * 100); };
  const toast = (msg) => { const t = document.querySelector('.c-toast'); if (!t) return; t.textContent = msg; t.hidden = false; clearTimeout(toast.t); toast.t = setTimeout(() => (t.hidden = true), 2600); };

  /* Countdown + end of offer. Runs on every page: the cart drawer can gain a countdown after load. */
  let ended = false;
  const endOffer = () => {
    if (ended) return; ended = true;
    document.querySelectorAll('[data-eh55],[data-eh55-block],[data-eh55-cart],[data-eh55-cd],[data-x55]').forEach((el) => el.remove());
  };
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    document.querySelectorAll('[data-eh55-cd]').forEach((cd) => {
      const end = Date.parse(cd.dataset.eh55Cd); if (isNaN(end)) return;
      let s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { endOffer(); return; }
      const d = Math.floor(s / 86400); s %= 86400; const h = Math.floor(s / 3600); s %= 3600; const m = Math.floor(s / 60); s %= 60;
      const set = (u, v) => { const b = cd.querySelector(`[data-u="${u}"]`); if (b && b.textContent !== v) b.textContent = v; };
      set('d', String(d)); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
    });
  };
  tick(); setInterval(tick, 1000);

  /* Homepage hero: rotate the watches */
  document.querySelectorAll('[data-x55]').forEach((sec) => {
    const cards = [...sec.querySelectorAll('.x55__card')], dots = [...sec.querySelectorAll('.x55__dots i')];
    if (cards.length < 2 || reduce) return;
    let k = 0, t = null, vis = true;
    const show = () => {
      cards.forEach((c, j) => { const was = c.classList.contains('is-in'); c.classList.toggle('is-in', j === k); c.classList.toggle('is-out', j !== k && was); c.setAttribute('aria-hidden', j === k ? 'false' : 'true'); c.tabIndex = j === k ? 0 : -1; });
      dots.forEach((d, j) => d.classList.toggle('on', j === k));
      setTimeout(() => cards.forEach((c, j) => { if (j !== k) c.classList.remove('is-out'); }), 500);
    };
    const run = () => { clearInterval(t); t = null; if (vis && !document.hidden) t = setInterval(() => { k = (k + 1) % cards.length; show(); }, 3200); };
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { vis = e.isIntersecting; run(); }, { threshold: 0.2 }).observe(sec);
    document.addEventListener('visibilitychange', run);
    run();
  });

  /* Product page: "your price with code" follows the selected size */
  document.querySelectorAll('[data-product]').forEach((sec) => {
    const wrap = sec.querySelector('[data-price-wrap]'), po = sec.querySelector('[data-eh55-po]');
    if (!wrap || !po) return;
    const amt = +po.dataset.eh55Amount, out = po.querySelector('[data-eh55-po-price]');
    if (!(amt > 0) || !out) return;
    const upd = () => { const p = shown(wrap); if (p !== null) out.innerHTML = money(Math.max(0, p - amt)); };
    new MutationObserver(upd).observe(wrap, { childList: true, subtree: true });
    upd();
  });

  /* Quick-add sheet: remember whether the product that opened it is eligible */
  let qaSrc = null;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-add],[data-cover-add],[data-deck-add]'); if (!b) return;
    let scope = b.closest('[data-product-card],.c-best__card');
    if (!scope && b.hasAttribute('data-cover-add')) { const s = b.closest('[data-coverflow]'); scope = s && s.querySelector('[data-cover-slide].is-active'); }
    if (!scope && b.hasAttribute('data-deck-add')) { const s = b.closest('[data-deck]'); scope = s && s.querySelector('[data-deck-card].is-on'); }
    const tag = scope && scope.querySelector('[data-eh55]');
    qaSrc = tag ? { code: tag.dataset.eh55Code, amt: +tag.dataset.eh55Amount } : null;
  }, true);
  new MutationObserver(() => {
    if (!qaSrc || ended) return;
    const box = document.querySelector('.c-qa [data-qa-price]');
    if (!box || box.querySelector('[data-eh55]')) return;
    const p = shown(box); if (p !== null) box.insertAdjacentHTML('beforeend', line(p, qaSrc.code, qaSrc.amt, 'md'));
  }).observe(document.body, { childList: true, subtree: true });

  /* Copy buttons (banner, offer row, hero) */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-eh55-copy]'); if (!b) return;
    e.preventDefault();
    const txt = b.dataset.eh55Copy, msg = b.dataset.copied || '';
    try { await navigator.clipboard.writeText(txt); } catch (err) {
      const t = document.createElement('textarea'); t.value = txt; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0'; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e2) {} t.remove();
    }
    if (!b.dataset.orig) b.dataset.orig = b.innerHTML;
    b.innerHTML = `<b dir="ltr">${esc(txt)}</b> ✓ ${esc(msg)}`; b.classList.add('is-done');
    toast(`${msg} · ${txt}`);
    clearTimeout(b._t); b._t = setTimeout(() => { b.innerHTML = b.dataset.orig; b.classList.remove('is-done'); }, 2200);
  });

  /* Cart: apply the code through Shopify, then show what Shopify confirms */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-eh55-apply]'); if (!b) return;
    e.preventDefault();
    const code = b.dataset.eh55Apply, box = b.closest('[data-eh55-cart]'), msg = box && box.querySelector('[data-eh55-msg]');
    const fail = () => { if (msg) msg.textContent = T.err; b.disabled = false; b.classList.remove('is-loading'); };
    b.disabled = true; b.classList.add('is-loading');
    try {
      const r = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) });
      const j = await r.json();
      const ok = r.ok && (j.discount_codes || []).some((d) => String(d.code).toUpperCase() === code.toUpperCase() && d.applicable);
      if (!ok) { fail(); return; }
      if (b.closest('[data-cart-page]')) { location.reload(); return; }
      const s = await (await fetch(`${root}?sections=c-cart-drawer`)).json();
      const doc = new DOMParser().parseFromString(s['c-cart-drawer'] || '', 'text/html');
      const fresh = doc.querySelector('[data-cart-root]'), cur = document.querySelector('[data-cart-root]');
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; cur.dataset.count = fresh.dataset.count; tick(); } else location.reload();
    } catch (err) { fail(); }
  });
})();
